export const getHubletUrl = (url, hubletOriginOverride) => {
  if (!hubletOriginOverride) {
    return url;
  }
  if (!hubletOriginOverride.endsWith('/')) {
    hubletOriginOverride = `${hubletOriginOverride}/`;
  }
  return `${hubletOriginOverride}${url}`;
};